import * as React from "react"
import { Link } from "@inertiajs/react"
import { useTranslation } from "react-i18next"
import {
  FolderIcon,
  SettingsIcon,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { Logo } from "@/components/logo"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

interface User {
  id: number
  name: string
  email: string
  admin: boolean
  super_admin?: boolean
}

interface Project {
  id: number
  name: string
}

interface ProjectSidebarProps extends React.ComponentProps<typeof Sidebar> {
  user: User
  project: Project
}

export function ProjectSidebar({ user, project, ...props }: ProjectSidebarProps) {
  const { t } = useTranslation('common')

  const navMain: Array<{
    title: string
    url: string
    icon: typeof FolderIcon
    activePattern?: string
  }> = [
    {
      title: t('sidebar.project'),
      url: `/projects/${project.id}`,
      icon: FolderIcon,
    },
    ...(user.admin ? [{
      title: t('sidebar.settings'),
      url: `/projects/${project.id}/settings`,
      icon: SettingsIcon,
    }] : []),
  ]

  return (
    <Sidebar collapsible="icon" variant="floating" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild className="hover:bg-transparent active:bg-transparent data-[active=true]:bg-transparent">
              <Link href="/" className="group-data-[collapsible=icon]:justify-center">
                <div className="flex items-center justify-center w-full group-data-[collapsible=icon]:flex hidden">
                  <Logo iconOnly className="h-6 w-6" />
                </div>
                <div className="flex flex-1 items-center group-data-[collapsible=icon]:hidden">
                  <Logo className="h-6" />
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
    </Sidebar>
  )
}
